module.exports = __webpack_public_path__ + "img/chinesecompany195.afe3a478.png";